import { getKeys } from './getKeys'

export const gpConnectTranslations = {
  PATIENT_DETAILS: 'Patient Details',
  PATIENT_SUMMARY: 'Patient Summary',
  SUMMARY: 'Summary',
  ADDRESS: 'Address: ',
  GENDER: 'Gender: ',
  SEX: 'Sex: ',
  GP_DETAILS: 'GP Details: ',
  DOB: 'DOB: ',
  NHS_NO: 'NHS No.: ',
  PAS_NO: 'PAS No.: ',
  CONTACT: 'Contact: ',
  NOT_FOUND: 'Patient Record Not Found',
  OPS: 'Oops... Please contact support if this error persists',
  SITE_INFORMATION: 'Site information',
  TELEPHONE: 'Telephone',
  EDIT: 'Edit',
  CANCEL: 'Cancel',
  REGULATOR: 'Regulator',
  NO_INFORMATION_ADDED: 'No information added',
  WHERE_TO_FIND_YOUR: 'Where to find your Regulatory Identifier',
  REGULATORY_IDENTIFIER: 'Regulatory identifier',
  REGULATORY_BODY: 'Regulatory body',
  REGULATORY_person: 'Regulatory person',
  GP_CONNECT: 'GP Connect',
  INTEGRATION_SETUP: 'Integration Setup',
  ODS_CODE: 'ODS Code',
  ASID_CODE: 'ASID Code',
  START: 'Start',
  SIGN: 'Sign',
  GP_GAINING: 'GP Connect National Data Sharing Arrangement (NDSA)',
  DPO: 'Name of Registered Manager / DPO / Director: ',
  AGREED_DATE: 'Agreed date',
  AGREEMENT_SIGNED: 'AGREEMENT SIGNED',
  VIEW_DATA_SHARING: 'View National Data Sharing Agreement',
  NEXT_STEP: 'Next steps for setting up GP Connect',
  BE_AWARE: 'Please be aware that GP connect currently only covers England.',
  I_HAVE: 'I have read and understood the agreement',
  CANNOT: 'Can not find your ODS Code. Please ensure your DSPT is up to date',
  T0_GET_STARTED:
    'To get started with GP Connect, you need to enter your Regulatory Identifier.',
  WARNING:
    '▲ WARNING: You should only commit if you are known to be DSPT Standards Met. You will be in breach of the obligations set out if you sign and are not DSPT Standards Met.',
  UNREGULATED: 'Unregulated',
  GP_POLICY_SEC_1: 'Acceptable Use Policy',
  GP_POLICY_SEC_2: 'End User Organisation Acceptable Use Policy (AUP)',
  THE_PRIVACY:
    'The Privacy Notice for GP Connect must be signed before viewing this record',
  YOU_CAN_FIND_MORE_CONSENT: 'You can find the consent form',
  SET_UP_COMPLETED: 'SET UP COMPLETED',
  NON_CLINICAL: '(Non-clinical)',
  YOU_MUST:
    'You must complete GP Connect onboarding before viewing this record',
  THIS_PATIENT_1:
    'This patient does not have a valid NHS number which is required to view the record.',
  THIS_PATIENT_2: 'Add it to their',
  THIS_PATIENT_3: 'profile',
  THIS_PATIENT_4: 'under ‘Care related information’.',
  ERROR_DECEASED_PATIENT:
    'This record belongs to a deceased patient and cannot be accessed.',
  ERROR_SENSITIVE_PATIENT:
    'This record has been highlighted as sensitive and therefore cannot be shown.',
  UNEXPECTED_ERROR: 'An unexpected error occurred. Please try again.',
  SUPERSEDED_WARNING:
    'The NHS Number provided ({{nhsNumber}}) has been superseded ',
  PLEASE_UPDATE: 'Please update ',
  HERE: 'here',
  FAMILY_NAME_MISMATCH: 'Family Name does not match: {{familyName}}',
  GIVEN_NAME_MISMATCH: 'Given Name does not match: {{givenName}}',
  UPDATE_RECORDS: 'Please update your records ',
  GENDER_MISMATCH: 'Gender does not match: {{gender}}',
  SEX_MISMATCH: 'Sex does not match: {{sex}}',
  DOB_MISMATCH: 'Birth Date does not match: {{dob}}',
  INTEGRATION_SETUP_URL:
    'https://support.logmycare.co.uk/en/articles/10470275-how-to-set-up-gp-connect-integration'
}

export const gpConnectConstants = getKeys(gpConnectTranslations)
